// Traducciones del newsletter: la tarjeta de suscripción (blog, actualidad), /newsletter y los chips de las listas.
// Los nombres propios (Bison, ChatGPT, Gemini, Claude) se mantienen; cada entrada es [es, en, pt-BR].
// Las claves deben coincidir exacto con el texto, espacios finales incluidos.
export const newsletterMessages = Object.fromEntries(
  [
    // Formulario
    ['Todas las actualizaciones', 'All updates', 'Todas as atualizações'],
    ['Rankings', 'Rankings', 'Rankings'],
    ['Prensa', 'Press', 'Imprensa'],
    ['Nuestros datos, en los medios', 'Our data, in the media', 'Nossos dados, na mídia'],
    ['Las notas de prensa que citan nuestras mediciones, con el enlace a la fuente original.', 'Press articles that cite our measurements, with the link to the original source.', 'As matérias de imprensa que citam nossas medições, com o link para a fonte original.'],
    ['Ver en los medios', 'See in the media', 'Ver na mídia'],
    ['Lo nuevo en la plataforma', 'What’s new in the platform', 'O que há de novo na plataforma'],
    ['Las funciones que sumamos a Bison y cómo usarlas para medir y mejorar la visibilidad de tu marca en IA.', 'The features we add to Bison and how to use them to measure and improve your brand’s visibility in AI.', 'Os recursos que adicionamos à Bison e como usá-los para medir e melhorar a visibilidade da sua marca na IA.'],
    ['Ver la plataforma', 'See the platform', 'Ver a plataforma'],
    ['Eventos y webinars', 'Events and webinars', 'Eventos e webinars'],
    ['Sesiones en vivo', 'Live sessions', 'Sessões ao vivo'],
    ['Te avisamos de los eventos y webinars de Bison apenas abramos las inscripciones.', 'We let you know about Bison events and webinars as soon as registration opens.', 'Avisamos sobre os eventos e webinars da Bison assim que abrirmos as inscrições.'],
    ['Novedades', 'Product updates', 'Novidades'],
    ['Eventos', 'Events', 'Eventos'],
    ['Webinars', 'Webinars', 'Webinars'],
    ['Tu país', 'Your country', 'Seu país'],
    ['Blog', 'Blog', 'Blog'],
    ['Rankings Chile', 'Chile rankings', 'Rankings Chile'],
    ['Rankings Argentina', 'Argentina rankings', 'Rankings Argentina'],
    ['Rankings Brasil', 'Brazil rankings', 'Rankings Brasil'],
    ['Rankings Colombia', 'Colombia rankings', 'Rankings Colômbia'],
    ['Rankings Ecuador', 'Ecuador rankings', 'Rankings Equador'],
    ['Rankings México', 'Mexico rankings', 'Rankings México'],
    ['Rankings Perú', 'Peru rankings', 'Rankings Peru'],
    ['Rankings Uruguay', 'Uruguay rankings', 'Rankings Uruguai'],
    ['Suscribirse', 'Subscribe', 'Assinar'],
    ['Enviando…', 'Sending…', 'Enviando…'],
    ['Acepto los', 'I accept the', 'Aceito os'],
    ['Términos', 'Terms', 'Termos'],
    ['y la', 'and the', 'e a'],
    ['Política de privacidad', 'Privacy policy', 'Política de privacidade'],
    [
      'Cancela tu suscripción en cualquier momento.',
      'Cancel your subscription at any time.',
      'Cancele sua assinatura quando quiser.',
    ],
    [
      'Listo, quedaste suscrito/a. El próximo envío te llega a tu inbox.',
      'Done, you are subscribed. The next issue will reach your inbox.',
      'Pronto, você está inscrito(a). A próxima edição chega à sua caixa de entrada.',
    ],
    // Tarjeta de blog y actualidad, y encabezado de /newsletter
    ['Recibe lo nuevo de Bison en tu correo', 'Get what is new at Bison in your inbox', 'Receba as novidades da Bison no seu e-mail'],
    [
      'Artículos con fuentes, notas de actualidad y rankings por país. Elige qué quieres recibir.',
      'Articles with sources, news notes and rankings by country. Choose what you want to receive.',
      'Artigos com fontes, notas de atualidade e rankings por país. Escolha o que quer receber.',
    ],
    ['Newsletter', 'Newsletter', 'Newsletter'],
    [
      'Lo que cambia en la IA, directo a tu correo',
      'What changes in AI, straight to your inbox',
      'O que muda na IA, direto no seu e-mail',
    ],
    // Qué vas a encontrar
    ['Qué vas a encontrar', 'What you will find', 'O que você vai encontrar'],
    ['Lo que publicamos, en tu correo', 'What we publish, in your inbox', 'O que publicamos, no seu e-mail'],
    [
      'Tres tipos de contenido. Con los chips del formulario eliges cuáles recibir.',
      'Three kinds of content. Use the form chips to choose which ones you receive.',
      'Três tipos de conteúdo. Com os chips do formulário você escolhe quais receber.',
    ],
    ['Actualidad', 'News', 'Atualidade'],
    ['Rankings', 'Rankings', 'Rankings'],
    ['Prensa', 'Press', 'Imprensa'],
    ['Nuestros datos, en los medios', 'Our data, in the media', 'Nossos dados, na mídia'],
    ['Las notas de prensa que citan nuestras mediciones, con el enlace a la fuente original.', 'Press articles that cite our measurements, with the link to the original source.', 'As matérias de imprensa que citam nossas medições, com o link para a fonte original.'],
    ['Ver en los medios', 'See in the media', 'Ver na mídia'],
    ['Lo nuevo en la plataforma', 'What’s new in the platform', 'O que há de novo na plataforma'],
    ['Las funciones que sumamos a Bison y cómo usarlas para medir y mejorar la visibilidad de tu marca en IA.', 'The features we add to Bison and how to use them to measure and improve your brand’s visibility in AI.', 'Os recursos que adicionamos à Bison e como usá-los para medir e melhorar a visibilidade da sua marca na IA.'],
    ['Ver la plataforma', 'See the platform', 'Ver a plataforma'],
    ['Eventos y webinars', 'Events and webinars', 'Eventos e webinars'],
    ['Sesiones en vivo', 'Live sessions', 'Sessões ao vivo'],
    ['Te avisamos de los eventos y webinars de Bison apenas abramos las inscripciones.', 'We let you know about Bison events and webinars as soon as registration opens.', 'Avisamos sobre os eventos e webinars da Bison assim que abrirmos as inscrições.'],
    ['Novedades', 'Product updates', 'Novidades'],
    ['Eventos', 'Events', 'Eventos'],
    ['Webinars', 'Webinars', 'Webinars'],
    ['Artículos con datos y fuentes', 'Articles with data and sources', 'Artigos com dados e fontes'],
    [
      'Análisis largos sobre cómo la IA elige y recomienda marcas en LatAm. Cada artículo trae datos propios y dos fuentes verificadas.',
      'Long analyses of how AI chooses and recommends brands in LatAm. Every article brings original data and two verified sources.',
      'Análises longas sobre como a IA escolhe e recomenda marcas na LatAm. Cada artigo traz dados próprios e duas fontes verificadas.',
    ],
    ['Ver el blog', 'See the blog', 'Ver o blog'],
    ['Lo que cambia, en una nota corta', 'What changes, in a short note', 'O que muda, em uma nota curta'],
    [
      'Novedades de los motores de IA y de la búsqueda, explicadas en pocas líneas y con la fuente a la vista.',
      'News from AI engines and search, explained in a few lines with the source in plain sight.',
      'Novidades dos motores de IA e da busca, explicadas em poucas linhas e com a fonte à vista.',
    ],
    ['Ver las notas', 'See the notes', 'Ver as notas'],
    ['Quién aparece, por industria y país', 'Who shows up, by industry and country', 'Quem aparece, por indústria e país'],
    [
      'Qué marcas mencionan ChatGPT, Gemini y Claude en Chile, Argentina, Brasil, Colombia, Ecuador, México, Perú y Uruguay.',
      'Which brands ChatGPT, Gemini and Claude mention in Chile, Argentina, Brazil, Colombia, Ecuador, Mexico, Peru and Uruguay.',
      'Quais marcas o ChatGPT, o Gemini e o Claude mencionam no Chile, Argentina, Brasil, Colômbia, Equador, México, Peru e Uruguai.',
    ],
    ['Ver los rankings', 'See the rankings', 'Ver os rankings'],
    // Un adelanto
    ['Un adelanto', 'A preview', 'Uma prévia'],
    ['Lo último que publicamos', 'The latest we published', 'O último que publicamos'],
    [
      'Así se ve lo que recibes: estos son los tres artículos más recientes del blog.',
      'This is what you get: the three most recent blog articles.',
      'É isto que você recebe: os três artigos mais recentes do blog.',
    ],
    // /newsletter con las piezas del sitio (banner, secciones, cierre)
    ['NEWSLETTER', 'NEWSLETTER', 'NEWSLETTER'],
    ['Gratis · cancela cuando quieras', 'Free · cancel anytime', 'Grátis · cancele quando quiser'],
    ['Lo que cambia en la IA,', 'What changes in AI,', 'O que muda na IA,'],
    ['directo a tu correo.', 'straight to your inbox.', 'direto no seu e-mail.'],
    [
      'Artículos con fuentes, rankings y eventos de tu país, Bison en la prensa, novedades de la plataforma y webinars. Eliges qué recibir y te das de baja con un clic.',
      'Articles with sources, rankings and events in your country, Bison in the press, platform updates and webinars. You choose what to receive and unsubscribe in one click.',
      'Artigos com fontes, rankings e eventos do seu país, a Bison na imprensa, novidades da plataforma e webinars. Você escolhe o que receber e cancela com um clique.',
    ],
    ['Suscribirme', 'Subscribe', 'Assinar'],
    ['Contenido', 'Content', 'Conteúdo'],
    ['3 tipos', '3 kinds', '3 tipos'],
    ['Blog, actualidad y rankings', 'Blog, news and rankings', 'Blog, atualidade e rankings'],
    ['8 países', '8 countries', '8 países'],
    ['Eliges los que te interesan', 'Pick the ones you follow', 'Escolha os que te interessam'],
    ['Costo', 'Cost', 'Custo'],
    ['Gratis', 'Free', 'Grátis'],
    ['Sin tarjeta ni cuenta', 'No card, no account', 'Sem cartão nem conta'],
    ['Baja', 'Unsubscribe', 'Cancelamento'],
    ['1 clic', '1 click', '1 clique'],
    ['Desde cualquier correo', 'From any email', 'Em qualquer e-mail'],
    ['01 / Suscríbete', '01 / Subscribe', '01 / Assine'],
    ['Elige qué recibir.', 'Choose what to receive.', 'Escolha o que receber.'],
    ['Nosotros te escribimos.', 'We write to you.', 'Nós escrevemos para você.'],
    [
      'Todas las actualizaciones o solo lo que te interesa: blog, prensa, los rankings de tu país, novedades de la plataforma, eventos y webinars. Te enviamos un correo para confirmar la suscripción.',
      'All updates or only what interests you: blog, press, your country’s rankings, platform updates, events and webinars. We send you an email to confirm your subscription.',
      'Todas as atualizações ou só o que te interessa: blog, imprensa, os rankings do seu país, novidades da plataforma, eventos e webinars. Enviamos um e-mail para confirmar a assinatura.',
    ],
    ['02 / Qué vas a encontrar', '02 / What you will find', '02 / O que você vai encontrar'],
    ['Lo que publicamos,', 'What we publish,', 'O que publicamos,'],
    ['en tu correo.', 'in your inbox.', 'no seu e-mail.'],
    [
      'Seis tipos de contenido. En el formulario eliges cuáles recibir.',
      'Six kinds of content. In the form you choose which ones to receive.',
      'Seis tipos de conteúdo. No formulário você escolhe quais receber.',
    ],
    ['03 / Un adelanto', '03 / A preview', '03 / Uma prévia'],
    ['Lo último que publicamos,', 'The latest we published,', 'O último que publicamos,'],
    ['tal como te llega.', 'just as you get it.', 'do jeito que chega para você.'],
    [
      'Los tres artículos más recientes del blog.',
      'The three most recent blog articles.',
      'Os três artigos mais recentes do blog.',
    ],
    ['Leer el artículo', 'Read the article', 'Ler o artigo'],
    ['¿Quieres ver cómo aparece tu marca?', 'Want to see how your brand shows up?', 'Quer ver como sua marca aparece?'],
    ['6 tipos', '6 types', '6 tipos'],
    ['Blog, rankings, eventos y más', 'Blog, rankings, events and more', 'Blog, rankings, eventos e mais'],
    ['Eliges el tuyo', 'Pick yours', 'Escolha o seu'],
    ['Te lo mostramos en una demo.', 'We show you in a demo.', 'Mostramos em uma demo.'],
    // Envío al CRM con doble confirmación (INI-1081)
    [
      'Te enviamos un correo para confirmar tu suscripción. Ábrelo y confirma para empezar a recibirlo.',
      'We sent you an email to confirm your subscription. Open it and confirm to start receiving it.',
      'Enviamos um e-mail para confirmar sua assinatura. Abra e confirme para começar a recebê-la.',
    ],
    // /newsletter/confirmar/ y /newsletter/baja/
    ['Confirmar', 'Confirm', 'Confirmar'],
    ['Confirma tu', 'Confirm your ', 'Confirme sua '],
    ['suscripción.', 'subscription.', 'assinatura.'],
    [
      'Un clic y empiezas a recibir lo que elegiste. Si no te suscribiste tú, ignora el correo: sin confirmar no te enviamos nada.',
      'One click and you start receiving what you chose. If you did not subscribe, ignore the email: without confirmation we send you nothing.',
      'Um clique e você começa a receber o que escolheu. Se não foi você quem se inscreveu, ignore o e-mail: sem confirmação não enviamos nada.',
    ],
    ['01 / Confirmar', '01 / Confirm', '01 / Confirmar'],
    ['El enlace del correo dura 48 horas.', 'The link in the email lasts 48 hours.', 'O link do e-mail vale por 48 horas.'],
    ['Darse de baja', 'Unsubscribe', 'Cancelar inscrição'],
    ['Date de baja', 'Unsubscribe ', 'Cancele sua inscrição '],
    ['del newsletter.', 'from the newsletter.', 'da newsletter.'],
    [
      'Un clic y dejas de recibir el newsletter de Bison. Puedes volver a suscribirte cuando quieras.',
      'One click and you stop receiving the Bison newsletter. You can subscribe again whenever you want.',
      'Um clique e você deixa de receber a newsletter da Bison. Pode se inscrever de novo quando quiser.',
    ],
    ['01 / Darse de baja', '01 / Unsubscribe', '01 / Cancelar inscrição'],
    [
      'Dejas de recibir todas las listas a las que te suscribiste con este correo.',
      'You stop receiving every list you subscribed to with this email.',
      'Você deixa de receber todas as listas em que se inscreveu com este e-mail.',
    ],
    ['Un clic', 'One click', 'Um clique'],
    ['y dejas de recibirlo.', 'and you stop receiving it.', 'e você deixa de recebê-la.'],
    ['Confirmar suscripción', 'Confirm subscription', 'Confirmar assinatura'],
    [
      'Listo: tu suscripción quedó confirmada. El próximo envío te llega a este correo.',
      'Done: your subscription is confirmed. The next issue arrives at this email.',
      'Pronto: sua assinatura foi confirmada. O próximo envio chega a este e-mail.',
    ],
    ['Darme de baja', 'Unsubscribe me', 'Cancelar minha inscrição'],
    [
      'Listo: te diste de baja y no te enviaremos más correos del newsletter.',
      'Done: you unsubscribed and we will not send you more newsletter emails.',
      'Pronto: você cancelou a inscrição e não enviaremos mais e-mails da newsletter.',
    ],
    [
      'Este enlace no trae el código del correo. Ábrelo de nuevo desde el correo que te enviamos.',
      'This link is missing the code from the email. Open it again from the email we sent you.',
      'Este link não traz o código do e-mail. Abra de novo a partir do e-mail que enviamos.',
    ],
    [
      'No pudimos completarlo: el enlace puede haber vencido (dura 48 horas). Suscríbete de nuevo o escríbenos a hello@bisonagents.com.',
      'We could not complete it: the link may have expired (it lasts 48 hours). Subscribe again or write to hello@bisonagents.com.',
      'Não conseguimos concluir: o link pode ter expirado (vale por 48 horas). Inscreva-se de novo ou escreva para hello@bisonagents.com.',
    ],
    ['¿Quieres cambiar qué recibes?', 'Want to change what you receive?', 'Quer mudar o que recebe?'],
    ['Volver al newsletter', 'Back to the newsletter', 'Voltar à newsletter'],
    // Consentimiento del formulario de /contacto
    ['Usamos tus datos solo para responder tu solicitud.', 'We use your data only to answer your request.', 'Usamos seus dados apenas para responder à sua solicitação.'],
    ['Necesitamos tu consentimiento para responderte.', 'We need your consent to reply to you.', 'Precisamos do seu consentimento para responder.'],
  ].map(([es, ...traducciones]) => [es, traducciones]),
);
